/**
 * Dedicated axios instance for the HOA Homeowner Portal.
 *
 * Separate from the main admin/agent `api.js` so that:
 *  - A 401 from a homeowner call doesn't log out an admin viewing the site
 *    in another tab (and vice versa).
 *  - The homeowner token (`hoa_token`) is stored under its own key.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const hoaApi = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

hoaApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('hoa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

hoaApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith('/hoa') && !window.location.pathname.endsWith('/login')) {
      localStorage.removeItem('hoa_token');
      localStorage.removeItem('hoa_homeowner');
      // Redirect to the homeowner login (NOT the admin "/" redirect)
      window.location.href = '/hoa/login';
    }
    return Promise.reject(err);
  },
);

export default hoaApi;

export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
